var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.value,
            direction: "rtl",
            size: "1100px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", { attrs: { span: _vm.gridSpan } }, [
                        _c(
                          "div",
                          { staticClass: "acea-row row-column row-middle" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.op === "edit"
                                    ? "活动真实用户"
                                    : "参与总人数"
                                )
                              ),
                            ]),
                            _c("el-link", { attrs: { type: "primary" } }, [
                              _vm._v(_vm._s(_vm.statistics.total) + "人"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(_vm.statistics.prizeList, function (item, index) {
                        return _c(
                          "el-col",
                          { key: index, attrs: { span: _vm.gridSpan } },
                          [
                            _c(
                              "div",
                              { staticClass: "acea-row row-column row-middle" },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(item.awardName) +
                                      "：" +
                                      _vm._s(item.prizeName)
                                  ),
                                ]),
                                _vm.op === "edit"
                                  ? _c(
                                      "el-link",
                                      { attrs: { type: "primary" } },
                                      [_vm._v(_vm._s(item.winnerCount) + "人")]
                                    )
                                  : _c(
                                      "el-link",
                                      { attrs: { type: "primary" } },
                                      [
                                        _vm._v(
                                          _vm._s(item.claimedCount) +
                                            "人领取 领奖率：" +
                                            _vm._s(item.claimRate) +
                                            "%"
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入用户名称",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery($event)
                              },
                            },
                            model: {
                              value: _vm.queryParams.userName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "userName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryParams.userName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入手机号",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery($event)
                              },
                            },
                            model: {
                              value: _vm.queryParams.phoneNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "phoneNumber",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryParams.phoneNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "抽奖码：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入兑奖码",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery($event)
                              },
                            },
                            model: {
                              value: _vm.queryParams.lotteryCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "lotteryCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryParams.lotteryCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "钱包余额大于：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              type: "number",
                              placeholder: "请输入金额",
                              clearable: "",
                              controls: false,
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery($event)
                              },
                            },
                            model: {
                              value: _vm.queryParams.minFreezeBalance,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "minFreezeBalance",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryParams.minFreezeBalance",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.op === "edit"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "排除奖项：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    multiple: "",
                                    placeholder: "请选择排除奖项",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryParams.excludePrizeIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "excludePrizeIds",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.excludePrizeIds",
                                  },
                                },
                                _vm._l(
                                  _vm.prizeOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.awardName,
                                        value: item.prizeId,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleQuery },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.resetQuery } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-card",
            {
              staticClass: "table-card mt14",
              attrs: { "body-style": { padding: "20px" } },
            },
            [
              _vm.op === "edit"
                ? _c(
                    "div",
                    { staticClass: "acea-row mb10" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            disabled: !_vm.multipleSelection.length,
                          },
                          on: { click: _vm.showPrizeModal },
                        },
                        [_vm._v("设置奖品")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.list, size: "small" },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _vm.op === "edit"
                        ? _c("el-table-column", {
                            attrs: { type: "selection", width: "55" },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          prop: "userId",
                          label: "用户ID",
                          "min-width": "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "user",
                          label: "用户",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c("el-image", {
                                        staticClass: "mr8",
                                        attrs: {
                                          src: row.userAvatar,
                                          "preview-src-list": [row.userAvatar],
                                        },
                                      }),
                                      _c("div", [
                                        _c("div", [
                                          _vm._v(_vm._s(row.userName)),
                                        ]),
                                        _c("div", [
                                          _vm._v(_vm._s(row.phoneNumber)),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          214081258
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "freezeBalancePrice",
                          label: "钱包余额",
                          "min-width": "120",
                        },
                      }),
                      _vm.op === "edit"
                        ? [
                            _c("el-table-column", {
                              attrs: {
                                prop: "lotteryCodeNum",
                                label: "抽奖码数量",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "winsFlag",
                                label: "是否中奖",
                                align: "center",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(row.winsFlag ? "是" : "否") +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4005890524
                              ),
                            }),
                          ]
                        : [
                            _c("el-table-column", {
                              attrs: {
                                prop: "redeemCode",
                                label: "抽奖码",
                                "min-width": "100",
                              },
                            }),
                          ],
                      _c("el-table-column", {
                        attrs: {
                          prop: "prizeInfo",
                          label: "奖品",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm.op !== "edit"
                        ? [
                            _c("el-table-column", {
                              attrs: {
                                prop: "redPacketPrice",
                                label: "中奖金额",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "winStatusDesc",
                                label: "奖品状态",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.winStatusMap[row.winStatus]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                544208741
                              ),
                            }),
                          ]
                        : _vm._e(),
                      [
                        _c("el-table-column", {
                          attrs: {
                            width: "100",
                            fixed: "right",
                            label: "操作",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.winsFlag
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelPrize(row)
                                              },
                                            },
                                          },
                                          [_vm._v("取消中奖")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            175235180
                          ),
                        }),
                      ],
                    ],
                    2
                  )
                : _vm._e(),
              _c("el-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0",
                  },
                ],
                attrs: {
                  background: "",
                  "current-page": _vm.queryParams.page,
                  "page-size": _vm.queryParams.limit,
                  "page-sizes": _vm.$constants.page.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryParams, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryParams, "page", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryParams, "limit", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryParams, "limit", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "设置奖项",
            visible: _vm.box.show,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.box, "show", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "奖项：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择奖项" },
                      model: {
                        value: _vm.box.prizeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.box, "prizeId", $$v)
                        },
                        expression: "box.prizeId",
                      },
                    },
                    _vm._l(_vm.prizeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.awardName, value: item.prizeId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.loading },
                  on: { click: _vm.setPrize },
                },
                [_vm._v("确定")]
              ),
              _c("el-button", { on: { click: _vm.closePrizeModal } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }